"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giovanni-la-punta": {
    "586dde1f": [{
      "hkey": "48201347",
      "slug": "san-giovanni-la-punta",
      "name": "San Giovanni la Punta",
      "primary": true,
      "skipSearch": false
    }],
    "trappeto": [{
      "hkey": "48201347",
      "slug": "san-giovanni-la-punta",
      "name": "San Giovanni la Punta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;